export default (newFn, rest) => (...args) => {
  const newResult = newFn(...args);
  if (newResult !== undefined && newResult !== null) {
    return newResult;
  }

  return rest(...args);
};



// WEBPACK FOOTER //
// ./lib/convert/html/draft-convert-html/util/accumulateFunction.js